import { ScrollReveal } from "@/components/ScrollReveal";
import { useCopy } from "@/lib/i18n/copy";
import { STATEMENT } from "@/content/pages/home";

const StatementSection = () => {
  const { t, fb } = useCopy(STATEMENT);
  return (
    <section id="atelier" className="section-luxury bg-background" data-header-theme="light" {...fb}>
      <div className="luxury-container">
        <ScrollReveal>
          <div className="max-w-5xl mx-auto">
            <h2 className="text-editorial text-heading mb-8 text-center">
              {t.h2}
            </h2>
            <div className="columns-1 md:columns-2 gap-8 text-foreground/80 text-[15px] md:text-base leading-[1.75] space-y-4 [column-fill:balance]">
              {t.paragraphs.map((text, i) => (
                <p key={i}>
                  {text}
                </p>
              ))}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default StatementSection;
